
<template>
    <li class="nav-item dropdown">
        <a
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            href=""
        >
            <img
                src="/img/bell.png"
                alt=""
                @click="showMessages"
            >
            <span class="badge badge-pill" v-if="quantityOfMessages">{{quantityOfMessages}}</span>
        </a>

        <div class="dropdown-menu">
            <div class="drop-title">Notifications</div>
            <div class="scrollbar" style="overflow: auto;">
                <a
                    :href="notification.data.link"
                    class="item"
                    v-for="notification in listOfNotifications"
                    :key="notification.id"
                >
                    <div class="item-inner">
                        <div class="item-ttl">
                            <h5>{{notification.data.title}}</h5>
                            <div class="date-time">{{formatDate(notification.created_at)}}</div>
                        </div>
                        <p >{{notification.data.body}}</p>
                    </div>
                </a>

            </div>
            <a href="/master-admin/notifications" class="view-all">View All</a>
        </div>
    </li>

</template>

<script>
import NotificationsService from "./Services/NotificationsService";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";

export default {
    name: 'NotificationsModal',
    props: {
        user: {
            type: Object,
            required: true,
        }
    },
    mixins: [DateConverter],
    data() {
        return {
            unreadMessagesIds: [],
            listOfNotifications:[],
            quantityOfMessages: null,
        }
    },
    methods: {
        getMessagesId() {
            this.unreadMessagesIds = this.listOfNotifications.map(m => m.id)
        },
         showMessages() {
            if (this.listOfNotifications.length < 0) {
                window.location.href = '/master-admin/notifications'
            } else {
               this.resetUnreadMessages()
            }
        },
        async  resetUnreadMessages() {
             this.quantityOfMessages = null
            try {
                await NotificationsService.readMessages(this.user.id, this.unreadMessagesIds)
            } catch (e) {
                console.error(e)
            }
        },

        async getListOfNotifications() {
            try {
                const {data: response} = await NotificationsService.getUnreadNotifications(this.user.id)
                this.listOfNotifications = response
                this.quantityOfMessages = this.listOfNotifications.length
                this.getMessagesId()
            } catch (e) {
                console.error(e)
            }
        },
    },
    mounted() {
        this.getListOfNotifications()
    }
}

</script>

<style scoped>

</style>
